export const ROXY_LISTEN_STORAGE_KEY = 'fetmode.studio.roxy.listen';
export const STUDIO_CAMERA_CYCLE_EVENT = 'fetmode:studio-cycle-camera';

export function readRoxyListenEnabled(): boolean {
  try {
    return window.localStorage.getItem(ROXY_LISTEN_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeRoxyListenEnabled(enabled: boolean): void {
  try {
    window.localStorage.setItem(ROXY_LISTEN_STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
}

export function requestStudioCameraCycle(): void {
  window.dispatchEvent(new Event(STUDIO_CAMERA_CYCLE_EVENT));
}
